import React, { useState } from "react"

import PropTypes from "prop-types"
import ArrowOpen from "../../assets/images/arrow_open_dark.svg"
import ArrowClose from "../../assets/images/arrow_close_white.svg"
import useCustomTranslation from "@hooks/useCustomTranslation"
const FaqSection = ({ questions }) => {
  const { t } = useCustomTranslation()
  const [questionOpen, setQuestionOpen] = useState(null)

  const defaultQuestions = [
    {
      title: t("Faq_1_Question_Price_Pages"),
      answer: t("Faq_1_Answer_Price_Pages"),
    },
    {
      title: t("Faq_2_Question_Price_Pages"),
      answer: t("Faq_2_Answer_Price_Pages"),
    },
    {
      title: t("Faq_3_Question_Price_Pages"),
      answer: t("Faq_3_Answer_Price_Pages"),
    },
  ]

  const questionsToRender = questions.length > 0 ? questions : defaultQuestions

  const openQuestion = index => {
    setQuestionOpen(questionOpen === index ? null : index)
  }

  return (
    <div className="bg-lblue pt-10 pb-5 md:pb-10 desk:p-15 font-inter">
      <div className="w-full md:w-[680px] desk:w-[1136px] m-auto">
        <p className="desk:text-center text-dblue text-20 desk:text-40 font-medium mb-4 desk:mb-10 ml-6 md:ml-0 leading-6">
          {t("Faq_Title_Price_Pages")}
        </p>
        {questionsToRender.map((question, index) => (
          <div
            key={index}
            className="bg-white m-auto mb-0.5 cursor-pointer"
            onClick={() => openQuestion(index)}
          >
            <div
              className={`flex justify-between pr-8 ${
                questionOpen === index
                  ? "bg-dblue text-white"
                  : "bg-white text-bgblue"
              }`}
            >
              <p className="flex p-6 pl-6 align-center text-14 desk:text-24">
                {question.title}
              </p>
              <img
                src={questionOpen === index ? ArrowClose : ArrowOpen}
                alt="toggle"
                className="w-4 desk:w-6"
              />
            </div>
            <p
              className={
                questionOpen === index
                  ? "flex p-7 pl-6 desk:mr-20 align-center text-g82 text-14 desk:text-16"
                  : "hidden"
              }
            >
              {question.answer}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}

FaqSection.defaultProps = {
  questions: [],
}

FaqSection.propTypes = {
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      answer: PropTypes.string,
    })
  ),
}

export default FaqSection
